// Generated by BUCKLESCRIPT VERSION 2.2.3, PLEASE EDIT WITH CARE
'use strict';

var Css = require("bs-css/lib/js/src/Css.js");
var Seed = require("./seed");
var $$Array = require("bs-platform/lib/js/array.js");
var Block = require("bs-platform/lib/js/block.js");
var Curry = require("bs-platform/lib/js/curry.js");
var Theme = require("./theme");
var React = require("react");
var Js_exn = require("bs-platform/lib/js/js_exn.js");
var Network = require("./network");
var Caml_obj = require("bs-platform/lib/js/caml_obj.js");
var Caml_array = require("bs-platform/lib/js/caml_array.js");
var Caml_int32 = require("bs-platform/lib/js/caml_int32.js");
var Caml_format = require("bs-platform/lib/js/caml_format.js");
var ReasonReact = require("reason-react/lib/js/src/ReasonReact.js");
var Check_onSvg = require("./assets/check_on.svg");
var Check_offSvg = require("./assets/check_off.svg");
var Info_iconSvg = require("./assets/info_icon.svg");
var Caml_builtin_exceptions = require("bs-platform/lib/js/caml_builtin_exceptions.js");
var Present_iconSvg = require("./assets/present_icon.svg");
var Bonus_workout_patternPng = require("./assets/bonus_workout_pattern.png");

var card = Css.style(/* :: */[
      Css.display(Css.flexBox),
      /* :: */[
        Css.fontSize(Theme.standardFontSize),
        /* [] */0
      ]
    ]);

var workout = Css.style(/* :: */[
      Css.flexDirection(Css.column),
      /* :: */[
        Css.alignItems(Css.center),
        /* :: */[
          Css.width(/* `percent */[
                -119887163,
                100.0
              ]),
          /* :: */[
            Css.backgroundImage(/* `url */[
                  5843823,
                  Bonus_workout_patternPng
                ]),
            /* [] */0
          ]
        ]
      ]
    ]);

var workoutBox = Css.style(/* :: */[
      Css.textAlign(Css.center),
      /* :: */[
        Css.display(Css.flexBox),
        /* :: */[
          Css.flexDirection(Css.column),
          /* :: */[
            Css.alignItems(Css.center),
            /* :: */[
              Css.boxSizing(Css.borderBox),
              /* :: */[
                Css.width(/* `percent */[
                      -119887163,
                      100.0
                    ]),
                /* :: */[
                  Css.padding4(Css.px(0), Css.px(12), Css.px(2), Css.px(12)),
                  /* :: */[
                    Css.margin4(Css.px(40), Css.px(0), Css.px(20), Css.px(0)),
                    /* [] */0
                  ]
                ]
              ]
            ]
          ]
        ]
      ]
    ]);

var workoutBoxInner = Css.style(/* :: */[
      Css.textAlign(Css.center),
      /* :: */[
        Css.display(Css.flexBox),
        /* :: */[
          Css.flexDirection(Css.column),
          /* :: */[
            Css.alignItems(Css.center),
            /* :: */[
              Css.borderRadius(Css.px(10)),
              /* :: */[
                Css.boxShadow(/* Some */[Css.px(2)], /* Some */[Css.px(2)], /* Some */[Css.px(4)], /* None */0, /* None */0, Css.rgba(255, 191, 194, 0.29)),
                /* :: */[
                  Css.width(/* `percent */[
                        -119887163,
                        100.0
                      ]),
                  /* [] */0
                ]
              ]
            ]
          ]
        ]
      ]
    ]);

var workoutBoxHeader = Css.style(/* :: */[
      Css.position(Css.relative),
      /* :: */[
        Css.display(Css.flexBox),
        /* :: */[
          Css.flexDirection(Css.column),
          /* :: */[
            Css.alignItems(Css.center),
            /* :: */[
              Css.background(/* `hex */[
                    5194459,
                    "FFFAFA"
                  ]),
              /* :: */[
                Css.margin4(Css.px(0), Css.px(0), Css.px(0), Css.px(0)),
                /* :: */[
                  Css.padding2(Css.px(0), Css.px(0)),
                  /* :: */[
                    Css.width(/* `percent */[
                          -119887163,
                          100.0
                        ]),
                    /* :: */[
                      Css.borderBottom(Css.px(2), /* solid */12956715, Css.hex("FCEBEC")),
                      /* [] */0
                    ]
                  ]
                ]
              ]
            ]
          ]
        ]
      ]
    ]);

var present = Css.style(/* :: */[
      Css.top(/* `percent */[
            -119887163,
            50.0
          ]),
      /* :: */[
        Css.transforms(/* :: */[
              /* `translate */[
                -914368690,
                /* tuple */[
                  Css.px(0),
                  /* `percent */[
                    -119887163,
                    -50.0
                  ]
                ]
              ],
              /* :: */[
                /* `scale */[
                  -120664438,
                  /* tuple */[
                    1.4,
                    1.4
                  ]
                ],
                /* [] */0
              ]
            ]),
        /* :: */[
          Css.position(/* absolute */-1013592457),
          /* :: */[
            Css.left(Css.px(14)),
            /* [] */0
          ]
        ]
      ]
    ]);

var selectHeader = Css.style(/* :: */[
      Css.fontSize(Css.px(24)),
      /* :: */[
        Css.margin4(Css.px(10), Css.px(0), Css.px(2), Css.px(0)),
        /* [] */0
      ]
    ]);

var flexList = Css.style(/* :: */[
      Css.width(/* `percent */[
            -119887163,
            100.0
          ]),
      /* :: */[
        Css.flexDirection(Css.column),
        /* :: */[
          Css.alignItems(Css.center),
          /* [] */0
        ]
      ]
    ]);

var mapElement = Css.style(/* :: */[
      Css.background(/* `hex */[
            5194459,
            "FFFAFA"
          ]),
      /* :: */[
        Css.flexDirection(Css.column),
        /* :: */[
          Css.width(/* `percent */[
                -119887163,
                100.0
              ]),
          /* :: */[
            Css.alignItems(Css.center),
            /* :: */[
              Css.paddingLeft(Css.px(12)),
              /* :: */[
                Css.paddingRight(Css.px(12)),
                /* :: */[
                  Css.boxSizing(Css.borderBox),
                  /* [] */0
                ]
              ]
            ]
          ]
        ]
      ]
    ]);

var mapElementCol = Css.style(/* :: */[
      Css.background(/* `hex */[
            5194459,
            "FFF"
          ]),
      /* :: */[
        Css.flexDirection(Css.column),
        /* :: */[
          Css.width(/* `percent */[
                -119887163,
                100.0
              ]),
          /* :: */[
            Css.alignItems(Css.center),
            /* :: */[
              Css.paddingLeft(Css.px(12)),
              /* :: */[
                Css.paddingRight(Css.px(12)),
                /* :: */[
                  Css.boxSizing(Css.borderBox),
                  /* [] */0
                ]
              ]
            ]
          ]
        ]
      ]
    ]);

var infoHeader = Css.style(/* :: */[
      Css.fontSize(Css.px(18)),
      /* :: */[
        Css.margin4(Css.px(18), Css.px(0), Css.px(6), Css.px(0)),
        /* [] */0
      ]
    ]);

var vertBox = Css.style(/* :: */[
      Css.width(/* `percent */[
            -119887163,
            100.0
          ]),
      /* :: */[
        Css.fontSize(Css.px(24)),
        /* :: */[
          Css.flexDirection(Css.column),
          /* :: */[
            Css.alignItems(Css.center),
            /* :: */[
              Css.margin4(Css.px(4), Css.px(0), Css.px(8), Css.px(0)),
              /* [] */0
            ]
          ]
        ]
      ]
    ]);

var horizonBox = Css.style(/* :: */[
      Css.position(Css.relative),
      /* :: */[
        Css.width(/* `percent */[
              -119887163,
              100.0
            ]),
        /* :: */[
          Css.flexDirection(Css.row),
          /* :: */[
            Css.justifyContent(Css.spaceBetween),
            /* :: */[
              Css.margin4(Css.px(14), Css.px(0), Css.px(14), Css.px(0)),
              /* [] */0
            ]
          ]
        ]
      ]
    ]);

var horizonBoxEl = Css.style(/* :: */[
      Css.display(Css.flexBox),
      /* :: */[
        Css.flexDirection(Css.row),
        /* :: */[
          Css.alignItems(Css.center),
          /* :: */[
            Css.paddingRight(Css.px(82)),
            /* :: */[
              Css.textAlign(/* left */-944764921),
              /* [] */0
            ]
          ]
        ]
      ]
    ]);

var horizonBoxElRight = Css.style(/* :: */[
      Css.top(/* `percent */[
            -119887163,
            50.0
          ]),
      /* :: */[
        Css.transform(/* `translate */[
              -914368690,
              /* tuple */[
                Css.px(0),
                /* `percent */[
                  -119887163,
                  -50.0
                ]
              ]
            ]),
        /* :: */[
          Css.fontWeight(700),
          /* :: */[
            Css.cursor(/* pointer */-786317123),
            /* :: */[
              Css.position(Css.absolute),
              /* :: */[
                Css.right(Css.px(0)),
                /* [] */0
              ]
            ]
          ]
        ]
      ]
    ]);

var horizonBoxSmallEl = Css.style(/* :: */[
      Css.margin4(Css.px(0), Css.px(8), Css.px(0), Css.px(8)),
      /* :: */[
        Css.fontSize(Css.px(18)),
        /* [] */0
      ]
    ]);

var initialBody = Css.style(/* :: */[
      Css.flexDirection(Css.row),
      /* :: */[
        Css.maxWidth(/* `percent */[
              -119887163,
              100.0
            ]),
        /* :: */[
          Css.justifyContent(/* center */98248149),
          /* :: */[
            Css.marginBottom(Css.px(5)),
            /* [] */0
          ]
        ]
      ]
    ]);

var initialBodyImgContainer1 = Css.style(/* :: */[
      Css.margin4(Css.px(5), Css.px(10), Css.px(3), Css.px(10)),
      /* :: */[
        Css.padding2(Css.px(0), Css.px(0)),
        /* :: */[
          Css.minWidth(Css.px(0)),
          /* :: */[
            Css.alignItems(/* center */98248149),
            /* :: */[
              Css.width(/* `percent */[
                    -119887163,
                    50.0
                  ]),
              /* [] */0
            ]
          ]
        ]
      ]
    ]);

var initialBodyImgContainer = Css.style(/* :: */[
      Css.margin4(Css.px(5), Css.px(3), Css.px(3), Css.px(3)),
      /* :: */[
        Css.padding2(Css.px(0), Css.px(0)),
        /* :: */[
          Css.minWidth(Css.px(0)),
          /* :: */[
            Css.alignItems(/* center */98248149),
            /* [] */0
          ]
        ]
      ]
    ]);

var initialBodyImg = Css.style(/* :: */[
      Css.maxWidth(/* `percent */[
            -119887163,
            100.0
          ]),
      /* [] */0
    ]);

var workoutNameHeader = Css.style(/* :: */[
      Css.fontSize(Css.px(18)),
      /* :: */[
        Css.fontWeight(400),
        /* :: */[
          Css.margin4(Css.px(8), Css.px(8), Css.px(10), Css.px(8)),
          /* [] */0
        ]
      ]
    ]);

var headHeader = Css.style(/* :: */[
      Css.margin4(Css.px(10), Css.px(0), Css.px(0), Css.px(0)),
      /* :: */[
        Css.padding2(Css.px(0), Css.px(5)),
        /* [] */0
      ]
    ]);

var subHeader = Css.style(/* :: */[
      Css.margin4(Css.px(0), Css.px(0), Css.px(10), Css.px(0)),
      /* :: */[
        Css.padding2(Css.px(0), Css.px(0)),
        /* :: */[
          Css.fontSize(Css.px(22)),
          /* [] */0
        ]
      ]
    ]);

var countDown = Css.style(/* :: */[
      Css.fontSize(Css.px(36)),
      /* :: */[
        Css.fontWeight(700),
        /* :: */[
          Css.margin4(Css.px(8), Css.px(8), Css.px(10), Css.px(8)),
          /* [] */0
        ]
      ]
    ]);

var spanEl = Css.style(/* :: */[
      Css.cursor(/* pointer */-786317123),
      /* :: */[
        Css.margin4(Css.px(0), Css.px(0), Css.px(0), Css.px(10)),
        /* [] */0
      ]
    ]);

var inputHeader = Css.style(/* :: */[
      Css.marginBottom(Css.px(10)),
      /* :: */[
        Css.marginTop(Css.px(10)),
        /* :: */[
          Css.fontWeight(700),
          /* [] */0
        ]
      ]
    ]);

var inputField = Css.style(/* :: */[
      Css.margin4(Css.px(5), Css.px(0), Css.px(8), Css.px(0)),
      /* :: */[
        Css.padding2(Css.px(5), Css.px(5)),
        /* :: */[
          Css.maxWidth(Css.px(120)),
          /* :: */[
            Css.fontSize(Css.px(30)),
            /* [] */0
          ]
        ]
      ]
    ]);

function horizonBoxElPlus(el, value) {
  var match = Caml_obj.caml_equal(el, value);
  return Css.style(/* :: */[
              Css.display(Css.flexBox),
              /* :: */[
                Css.flexGrow(1),
                /* :: */[
                  match !== 0 ? Css.background(Css.lightgreen) : Css.background(Css.lightblue),
                  /* :: */[
                    Css.margin4(Css.px(0), Css.px(10), Css.px(0), Css.px(10)),
                    /* :: */[
                      Css.fontSize(Css.px(24)),
                      /* :: */[
                        Css.minHeight(Css.px(40)),
                        /* :: */[
                          Css.maxWidth(Css.px(100)),
                          /* :: */[
                            Css.fontWeight(700),
                            /* :: */[
                              Css.cursor(/* pointer */-786317123),
                              /* :: */[
                                Css.justifyContent(Css.center),
                                /* :: */[
                                  Css.alignItems(Css.center),
                                  /* [] */0
                                ]
                              ]
                            ]
                          ]
                        ]
                      ]
                    ]
                  ]
                ]
              ]
            ]);
}

function settingButton() {
  return Css.style(/* :: */[
              Css.minWidth(Css.em(12.0)),
              /* :: */[
                Css.fontSize(Css.px(18)),
                /* :: */[
                  Css.margin4(Css.px(50), Css.px(8), Css.px(10), Css.px(8)),
                  /* :: */[
                    Css.maxWidth(Css.em(13.0)),
                    Theme.greenButtonRaw
                  ]
                ]
              ]
            ]);
}

var infoButton = Css.style(/* :: */[
      Css.top(/* `percent */[
            -119887163,
            50.0
          ]),
      /* :: */[
        Css.transform(/* `translate */[
              -914368690,
              /* tuple */[
                Css.px(0),
                /* `percent */[
                  -119887163,
                  -50.0
                ]
              ]
            ]),
        /* :: */[
          Css.position(/* absolute */-1013592457),
          /* :: */[
            Css.right(Css.px(42)),
            /* :: */[
              Css.cursor(/* pointer */-786317123),
              /* :: */[
                Css.margin4(Css.px(0), Css.px(0), Css.px(0), Css.px(10)),
                /* [] */0
              ]
            ]
          ]
        ]
      ]
    ]);

var infoIcon = Css.style(/* :: */[
      Css.margin2(Css.px(0), Css.px(8)),
      /* [] */0
    ]);

var checkIcon = Css.style(/* :: */[
      Css.margin2(Css.px(0), Css.px(8)),
      /* [] */0
    ]);

var someText = Css.style(/* :: */[
      Css.textAlign(/* left */-944764921),
      /* :: */[
        Css.fontSize(Theme.standardFontSize),
        /* :: */[
          Css.cursor(/* pointer */-786317123),
          /* :: */[
            Css.margin2(Css.px(10), Css.px(10)),
            /* :: */[
              Css.color(/* `hex */[
                    5194459,
                    "FF328C"
                  ]),
              /* :: */[
                Css.fontWeight(700),
                /* [] */0
              ]
            ]
          ]
        ]
      ]
    ]);

var Styles = /* module */[
  /* card */card,
  /* workout */workout,
  /* workoutBox */workoutBox,
  /* workoutBoxInner */workoutBoxInner,
  /* workoutBoxHeader */workoutBoxHeader,
  /* present */present,
  /* selectHeader */selectHeader,
  /* flexList */flexList,
  /* mapElement */mapElement,
  /* mapElementCol */mapElementCol,
  /* infoHeader */infoHeader,
  /* vertBox */vertBox,
  /* horizonBox */horizonBox,
  /* horizonBoxEl */horizonBoxEl,
  /* horizonBoxElRight */horizonBoxElRight,
  /* horizonBoxSmallEl */horizonBoxSmallEl,
  /* initialBody */initialBody,
  /* initialBodyImgContainer1 */initialBodyImgContainer1,
  /* initialBodyImgContainer */initialBodyImgContainer,
  /* initialBodyImg */initialBodyImg,
  /* workoutNameHeader */workoutNameHeader,
  /* headHeader */headHeader,
  /* subHeader */subHeader,
  /* countDown */countDown,
  /* spanEl */spanEl,
  /* inputHeader */inputHeader,
  /* inputField */inputField,
  /* horizonBoxElPlus */horizonBoxElPlus,
  /* settingButton */settingButton,
  /* infoButton */infoButton,
  /* infoIcon */infoIcon,
  /* checkIcon */checkIcon,
  /* someText */someText
];

function convToInt(theString) {
  try {
    return Caml_format.caml_int_of_string(theString);
  }
  catch (raw_exn){
    var exn = Js_exn.internalToOCamlException(raw_exn);
    if (exn[0] === Caml_builtin_exceptions.failure) {
      console.log("Issue with int conversion in workout component");
      return 0;
    } else {
      throw exn;
    }
  }
}

function checkForInt(x) {
  var x2 = convToInt(x);
  if (x2 >= 0 && x2 < 100) {
    return x2;
  } else {
    return 0;
  }
}

function turnBackToString(theInt) {
  if (theInt !== 0) {
    return String(theInt);
  } else {
    return "0";
  }
}

function text(prim) {
  return prim;
}

var component = ReasonReact.reducerComponent("Workout");

function make(week, _) {
  var newrecord = component.slice();
  newrecord[/* didMount */4] = (function () {
      return /* NoUpdate */0;
    });
  newrecord[/* render */9] = (function (self) {
      var repeater = $$Array.mapi((function (index, _) {
              var match = +(index % 2 === 1);
              var theStyle = match !== 0 ? mapElement : mapElementCol;
              var exId = Caml_array.caml_array_get(self[/* state */2][/* currentWorkoutExercisesIds */3], index);
              var block1 = React.createElement("div", {
                    className: initialBody
                  }, React.createElement("div", {
                        className: initialBodyImgContainer1
                      }, React.createElement("img", {
                            className: initialBodyImg,
                            alt: "image",
                            src: "/" + (String(exId) + "_l1_a.jpg")
                          })));
              var block2 = React.createElement("div", {
                    className: initialBody
                  }, React.createElement("div", {
                        className: initialBodyImgContainer
                      }, React.createElement("img", {
                            className: initialBodyImg,
                            alt: "image",
                            src: "/" + (String(exId) + "_l1_a.jpg")
                          })), React.createElement("div", {
                        className: initialBodyImgContainer
                      }, React.createElement("img", {
                            className: initialBodyImg,
                            alt: "image",
                            src: "/" + (String(exId) + "_l1_b.jpg")
                          })));
              var block3 = React.createElement("div", {
                    className: initialBody
                  }, React.createElement("div", {
                        className: initialBodyImgContainer
                      }, React.createElement("img", {
                            className: initialBodyImg,
                            alt: "",
                            src: "/" + (String(exId) + "_l1_a.jpg")
                          })), React.createElement("div", {
                        className: initialBodyImgContainer
                      }, React.createElement("img", {
                            className: initialBodyImg,
                            alt: "",
                            src: "/" + (String(exId) + "_l1_b.jpg")
                          })), React.createElement("div", {
                        className: initialBodyImgContainer
                      }, React.createElement("img", {
                            className: initialBodyImg,
                            alt: "",
                            src: "/" + (String(exId) + "_l1_c.jpg")
                          })));
              var match$1 = +(Caml_array.caml_array_get(self[/* state */2][/* bonusDoneWeek */4], index) === /* true */1);
              var match$2 = Caml_array.caml_array_get(self[/* state */2][/* showDetails */1], index);
              var tmp;
              if (match$2 !== 0) {
                var match$3 = Caml_array.caml_array_get(Caml_array.caml_array_get(Seed.exerciseImagesCount, exId - 1 | 0), 0);
                tmp = React.createElement("div", {
                      className: flexList
                    }, match$3 !== 1 ? (
                        match$3 !== 2 ? block3 : block2
                      ) : block1);
              } else {
                tmp = null;
              }
              var match$4 = Caml_array.caml_array_get(self[/* state */2][/* showDetails */1], index);
              return React.createElement("div", {
                          key: String(index),
                          className: theStyle
                        }, React.createElement("div", {
                              className: horizonBox
                            }, React.createElement("div", {
                                  className: horizonBoxEl
                                }, Caml_array.caml_array_get(self[/* state */2][/* currentWorkoutExercises */2], index)), React.createElement("div", {
                                  className: infoButton,
                                  onClick: (function () {
                                      return Curry._1(self[/* send */4], /* ToggleDetails */Block.__(3, [index]));
                                    })
                                }, React.createElement("img", {
                                      className: infoIcon,
                                      alt: "info",
                                      src: Info_iconSvg
                                    })), match$1 !== 0 ? React.createElement("div", {
                                    className: horizonBoxElRight,
                                    onClick: (function () {
                                        return Curry._1(self[/* send */4], /* UnCheckOne */Block.__(2, [index]));
                                      })
                                  }, React.createElement("img", {
                                        className: checkIcon,
                                        alt: "checkon",
                                        src: Check_onSvg
                                      })) : React.createElement("div", {
                                    className: horizonBoxElRight,
                                    onClick: (function () {
                                        return Curry._1(self[/* send */4], /* CheckOne */Block.__(1, [index]));
                                      })
                                  }, React.createElement("img", {
                                        className: checkIcon,
                                        alt: "checkoff",
                                        src: Check_offSvg
                                      }))), tmp, match$4 !== 0 ? React.createElement("div", {
                                className: someText
                              }, React.createElement("span", {
                                    dangerouslySetInnerHTML: {
                                      __html: Caml_array.caml_array_get(Caml_array.caml_array_get(Seed.exerciseDescriptions, exId - 1 | 0)[/* description */1], 0)
                                    }
                                  })) : null);
            }), /* array */[
            1,
            1,
            1,
            1,
            1,
            1
          ]);
      return React.createElement("div", {
                  className: workout
                }, React.createElement("div", {
                      className: workoutBox
                    }, React.createElement("div", {
                          className: workoutBoxInner
                        }, React.createElement("div", {
                              className: workoutBoxHeader
                            }, React.createElement("img", {
                                  className: present,
                                  alt: "Present",
                                  src: Present_iconSvg
                                }), React.createElement("h1", {
                                  className: headHeader
                                }, "Bonus"), React.createElement("h2", {
                                  className: subHeader
                                }, "Workout")), repeater)), React.createElement("button", {
                      className: settingButton(/* () */0),
                      onClick: (function () {
                          return ReasonReact.Router[/* push */0]("/week/" + (week + "/workoutweek/"));
                        })
                    }, "Zurück"));
    });
  newrecord[/* initialState */10] = (function () {
      return /* record */[
              /* workoutIndex */Caml_int32.imul(Caml_format.caml_int_of_string(week) - 1 | 0, 6) + (Caml_format.caml_int_of_string("6") - 1 | 0) | 0,
              /* showDetails : array */[
                /* false */0,
                /* false */0,
                /* false */0,
                /* false */0,
                /* false */0,
                /* false */0
              ],
              /* currentWorkoutExercises */Seed.getWorkoutTitles(week, "6"),
              /* currentWorkoutExercisesIds */Seed.getWorkoutIds(week, "6"),
              /* bonusDoneWeek */Caml_array.caml_array_get(Network.pullBonusConfig(/* () */0), Caml_format.caml_int_of_string(week) - 1 | 0),
              /* error : None */0,
              /* hide1 : false */0,
              /* hide2 : false */0,
              /* hide3 : false */0
            ];
    });
  newrecord[/* reducer */12] = (function (action, state) {
      if (typeof action === "number") {
        var details = /* array */[
          /* false */0,
          /* false */0,
          /* false */0,
          /* false */0,
          /* false */0,
          /* false */0
        ];
        var newrecord = state.slice();
        return /* UpdateWithSideEffects */Block.__(3, [
                  (newrecord[/* showDetails */1] = details, newrecord),
                  (function () {
                      console.log("nextroute", "nextRoute");
                      return ReasonReact.Router[/* push */0]("/dashboard/");
                    })
                ]);
      } else {
        switch (action.tag | 0) {
          case 0 : 
              var item = action[0];
              console.log("hiding: ", item);
              if (item !== 1) {
                if (item !== 2) {
                  var newrecord$1 = state.slice();
                  return /* Update */Block.__(0, [(newrecord$1[/* hide3 */8] = /* true */1, newrecord$1)]);
                } else {
                  var newrecord$2 = state.slice();
                  return /* Update */Block.__(0, [(newrecord$2[/* hide2 */7] = /* true */1, newrecord$2)]);
                }
              } else {
                var newrecord$3 = state.slice();
                return /* Update */Block.__(0, [(newrecord$3[/* hide1 */6] = /* true */1, newrecord$3)]);
              }
          case 1 : 
              var newBonusDoneWeek = state[/* bonusDoneWeek */4];
              Caml_array.caml_array_set(newBonusDoneWeek, action[0], /* true */1);
              var newrecord$4 = state.slice();
              return /* UpdateWithSideEffects */Block.__(3, [
                        (newrecord$4[/* bonusDoneWeek */4] = newBonusDoneWeek, newrecord$4),
                        (function () {
                            return Network.writeBonusToLs(week, newBonusDoneWeek);
                          })
                      ]);
          case 2 : 
              var newBonusDoneWeek$1 = state[/* bonusDoneWeek */4];
              Caml_array.caml_array_set(newBonusDoneWeek$1, action[0], /* false */0);
              var newrecord$5 = state.slice();
              return /* UpdateWithSideEffects */Block.__(3, [
                        (newrecord$5[/* bonusDoneWeek */4] = newBonusDoneWeek$1, newrecord$5),
                        (function () {
                            return Network.writeBonusToLs(week, newBonusDoneWeek$1);
                          })
                      ]);
          case 3 : 
              var item$1 = action[0];
              var showDetailsNew = $$Array.mapi((function (index, oldEntry) {
                      var match = +(index === item$1);
                      if (match !== 0) {
                        return 1 - oldEntry;
                      } else {
                        return /* false */0;
                      }
                    }), state[/* showDetails */1]);
              var newrecord$6 = state.slice();
              return /* Update */Block.__(0, [(newrecord$6[/* showDetails */1] = showDetailsNew, newrecord$6)]);
          
        }
      }
    });
  return newrecord;
}

exports.Styles = Styles;
exports.convToInt = convToInt;
exports.checkForInt = checkForInt;
exports.turnBackToString = turnBackToString;
exports.text = text;
exports.component = component;
exports.make = make;
/* card Not a pure module */



//////////////////
// WEBPACK FOOTER
// ./src/workoutWeekBonus.re
// module id = 159
// module chunks = 0